import * as yup from 'yup';
import { CategoryService } from '@/services/category';

export const formSchemaFn = (
  isActionEdit: boolean,
  isNotPermissionEdit: boolean,
  currentId?: number,
) =>
  yup.object().shape({
    name: yup
      .string()
      .trim()
      .required('カテゴリー名は未入力です。')
      .max(40, 'カテゴリー名は40文字以内で入力してください。')
      .test('name-unique', function (value) {
        if (!value) return true;
        return CategoryService.exists(value)
          .then((res) => {
            const existsId = res?.data ?? null;
            if (existsId === null) {
              return true;
            }
            if (!currentId) {
              const msg = `${value} は既に存在します。`;
              return this.createError({ path: 'name', message: msg });
            }
            if (Number(existsId) !== Number(currentId)) {
              const msg = `${value} は既に存在します。`;
              return this.createError({ path: 'name', message: msg });
            }
            return true;
          })
          .catch(() => true);
      }),
    sortOrder: yup
      .number()
      .typeError('並び順指定は数字で入力してください。')
      .integer('並び順指定は整数で入力してください。')
      .min(0, '並び順指定は0以上で入力してください。')
      .required('並び順指定は未入力です。'),
  });
